import Valuable from './base/valuable'

export default class Choice extends Valuable {
  constructor (name) {
    super()
    this.name = name
  }

  match (raw) {
    return raw === `${this.name} choice`
  }

  async getValue ({ character }) {
    return character.choices[this.name]
  }
}

Choice.TypeChoice = class TypeChoice extends Choice {
  constructor (name, recommendations, type) {
    super (name)
    Object.assign(this, { type, recommendations })
  }
}

Choice.FieldChoice = class FieldChoice extends Choice {
  constructor (name, field) {
    super(name)
    this.field = field
  }

  async getValue ({ character }) {
    const value = character.choices[this.name]
    if (Array.isArray(value) && Array.isArray(value[0])) { // Array of array options, reduce to a single array
      return value.reduce((all, subarr) => all.concat(subarr), [])
    }
    return value
  }
}

Choice.AssignmentChoice = class AssignmentChoice extends Choice {
  constructor (name, source, target, distinct) {
    super (name)
    Object.assign(this, { source, target, distinct })
  }
}
